export const TITLE = 'Hint/Caption';
export const PLACEHOLDER = 'A sample hint.';
